import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";

export class AuthInterceptorService implements  HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let modifiedRequest = req.clone({
      headers: req.headers.append('Authorization', 'Basic bW9iaWxlX2FwaV9jbGllbnQ6YWViNzBmNTktZmE1ZS00ZWZjLWIxZDUtNDg3MzY4YWQwNjA3')
    })
    return next.handle(modifiedRequest);
  }
}
